import { render, staticRenderFns } from "./PartnersPage.vue?vue&type=template&id=0b9f6ebc&scoped=true&"
import script from "./PartnersPage.vue?vue&type=script&lang=js&"
export * from "./PartnersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f6ebc",
  null
  
)

export default component.exports